<template>
  <transition name="modal">
    <div
      class="modal-mask handle-outside-modal-click"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      @click="handleModalClick"
      @keydown="handleModalKeyDown"
    >
      <div class="modal-wrapper handle-outside-modal-click">
        <div class="modal-container d-flex flex-column flex-sm-row">
          <div
            v-if="mediaURL"
            class="modal-image-container"
            :style="mediaStyle"
          />
          <div class="modal-content-container">
            <slot
              v-if="showCloseButton"
              name="close"
            >
              <LegacyModalCloseButton @click-close="closeModal" />
            </slot>
            <div
              v-if="!!$slots.header"
              class="modal-header"
            >
              <slot name="header" />
            </div>

            <div class="modal-body">
              <slot />
            </div>

            <div
              v-if="!!$slots.footer"
              class="modal-footer"
            >
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
  @import '../../styles/global';

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }

  .modal-container {
    max-width: fit-content;
    margin: 0 auto;

    /* padding: 20px 30px; */
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    display: flex;
    position: relative;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
    position: static;
  }

  .modal-default-button {
    float: right;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */
  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .modal-image-container {
    background-size: cover;
    background-position: center;
    order: 1;
  }

  .modal-container > div {
    width: auto;
  }

  .modal-content-container {
    order: 2;
  }

  .license-modal-container {
    .modal-mask {
      display: block;
      overflow-x: hidden;
      overflow-y: auto;
    }

    .modal-container {
      max-width: 950px;
      max-height: 700px;
      overflow: auto;
      margin: 5px auto;
      margin: auto;
    }

    .modal-content-container {
      width: 100%;
      height: 100%;
    }

    .modal-body {
      margin: 0;
      padding: 0;
    }
  }

  .dialog-popup-container {
    left: unset;
    bottom: unset;
    top: 20px;
    right: 40px !important;
    background-color: transparent;

    .modal-wrapper {
      top: unset;
      transform: none;
    }

    .modal-container {
      width: 450px;
      max-width: 450px;
      height: auto;
      max-height: 250px;
    }

    .modal-close-button {
      width: 14px;
      height: 14px;
      top: 22px !important;
      right: 20px !important;
    }

    .modal-close-button::before,
    .modal-close-button::after {
      height: 14px;
    }

    .modal-content-container {
      width: 100%;
      height: 100%;
    }

    .modal-body {
      padding: 20px;
      margin: 0;
    }
  }

  .comment-modal-container {
    &.modal-mask {
      display: block;
      overflow-x: hidden;
      overflow-y: auto;
    }

    .modal-header {
      margin-top: 2rem;
      padding-bottom: 2rem;
      border-top: 0;
    }

    .modal-content-container {
      width: 100%;
      height: 100%;
      padding: 0 3rem 3rem;
    }

    .modal-body {
      padding-left: 0;
      padding-right: 0;
      box-shadow: none;
    }

    .modal-container {
      width: auto;
      height: auto;
      max-width: 800px;
    }

    .modal-footer {
      padding-right: 0;
    }
  }

  .products-modal-container.modal-mask {
    display: block;
    overflow-x: hidden;
    overflow-y: auto;

    .modal-container {
      max-width: 1200px;
      overflow: auto;
      margin: 5px auto;
      margin: auto;
      width: auto;
      height: initial;
    }

    .modal-content-container {
      width: 100%;
      height: 100%;

      .modal-header {
        display: flex;
        justify-content: end;
        border: 0;
        padding: 0;
      }
    }

    .modal-body {
      box-shadow: initial;
      margin-top: 50px;
      padding: 0;
    }
  }

  @media (max-width: 981px) { // Matches nav mobile breakpoint
    .products-modal-container {
      .modal-wrapper {
        height: 100%;

        .modal-container {
          height: 100%;

          .modal-content-container {
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }

  @media (min-width: $license-modal-mobile) and (max-width: 1000px) {
    .license-modal-container .modal-container {
      max-width: 85%;
      max-height: 800px;
    }
  }

  @media (max-width: $license-modal-mobile) {
    .license-modal-container {
      .modal-container {
        max-height: 500px;
        width: 95%;
      }

      .modal-body {
        padding: 0;
      }

      .modal-image-container {
        height: 150px;
      }

      .modal-container > div {
        width: 100%;
      }
    }

    .dialog-popup-container {
      right: 20px !important;
      left: 20px;

      .modal-container {
        width: auto;
        max-width: 377px;
        height: auto;
        max-height: 300px;
      }

      .modal-close-button {
        top: 20px !important;
      }

      .modal-body {
        padding: 0;
      }
    }
  }
</style>

<script>
import get from 'lodash/get';
import LegacyModalCloseButton from './LegacyModalCloseButton.vue';

export default {
  components: {
    LegacyModalCloseButton,
  },
  props: {
    mediaURL: {
      type: String,
      default: '',
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ['click-close'],
  computed: {
    mediaStyle() {
      return {
        backgroundImage: `url(${this.mediaURL})`,
      };
    },
  },
  methods: {
    closeModal() {
      this.$emit('click-close');
    },
    handleModalClick(event) {
      const targetClasses = get(event, 'target.className', '');

      if (targetClasses.includes('handle-outside-modal-click')) {
        this.closeModal();
      }
    },
    handleModalKeyDown(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        this.closeModal();
      }
    },
  },
};
</script>
